import React, { ChangeEventHandler, FocusEventHandler, forwardRef, Ref } from 'react'

interface ITelProps {
  id: string
  value: string
  maxLength: number
  onChange: ChangeEventHandler<HTMLInputElement>
  onFocus: FocusEventHandler<HTMLInputElement>
  onBlur: FocusEventHandler<HTMLInputElement>
}

export const Tel = forwardRef((props: ITelProps, ref: Ref<HTMLInputElement>) => {
  return (
    <input
      type="tel"
      id={props.id}
      className="ipt-box__ipt-ghost"
      value={props.value}
      maxLength={props.maxLength}
      onChange={props.onChange}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      ref={ref}
    />
  )
})
